import { render } from "./ArticleDetail.vue?vue&type=template&id=2d5872eb&scoped=true&ts=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts"

import "./ArticleDetail.vue?vue&type=style&index=0&id=2d5872eb&lang=less&scoped=true"

import exportComponent from "F:\\luyou\\luyou_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5872eb"]])

export default __exports__